// urlNamespace must conform to the regex used by getSanitizedUrlNamespace in SiteService.java
export let SiteUrlNameCapturingRegex = /^\/site\/([-_a-zA-Z0-9]+)/;
